// frontend/src/pages/public/DocsHub.jsx
import React from "react";
import { Link } from "react-router-dom";
import { ArrowRightIcon } from "@heroicons/react/20/solid";
import Seo from "../../marketing/Seo";
import { Eyebrow } from "../../marketing/ui";
import { DOCS } from "../../marketing/docsContent";

export default function DocsHub() {
  return (
    <>
      <Seo
        title="Documentation"
        description="QRFlow documentation — getting started, REST API reference, FAQ, and troubleshooting."
        path="/docs"
      />
      <Eyebrow>Docs</Eyebrow>
      <h1 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
        QRFlow documentation
      </h1>
      <p className="mt-4 max-w-2xl text-lg text-gray-600">
        Everything you need to create dynamic codes, automate with the API, and get the
        most out of your analytics.
      </p>

      <div className="mt-10 grid gap-5 sm:grid-cols-2">
        {DOCS.map((d) => (
          <Link
            key={d.slug}
            to={`/docs/${d.slug}`}
            className="group rounded-2xl border border-gray-200 p-6 transition hover:border-brand-300 hover:shadow-sm"
          >
            <h2 className="flex items-center justify-between text-lg font-semibold text-gray-900">
              {d.title}
              <ArrowRightIcon className="h-5 w-5 text-gray-300 transition group-hover:translate-x-0.5 group-hover:text-brand-600" />
            </h2>
            <p className="mt-2 text-sm leading-6 text-gray-600">{d.description}</p>
          </Link>
        ))}
      </div>
    </>
  );
}
